export function getStatusUiModel(statusString="") {



  if (statusString === "focus") {
    return {
      label: statusString,
      textColor: "#92C4FF"
    };
  }
  if (statusString === "fury") {
    return {
      label: statusString,
      textColor: "#FF4F4F"
    };
  }
  if (statusString === "deadline") {
    return {
      label: statusString,
      textColor: "#54FFD9"
    };
  }
  if (statusString === "memory-leak") {
    return {
      label: "Memory Leak",
      textColor: "#F798A4"
    };
  }
  if (statusString === "lag") {
    return {
      label: statusString,
      textColor: "#FFF9A9"
    };
  }
  if (statusString === "fire") {
    return {
      label: statusString,
      textColor: "#FF7384"
    };
  }

  //default
  return {
    label: statusString,
    textColor: "#92C4FF"
  };




}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/getStatusUiModel.js